import { all, call, put, takeEvery } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchUserClassifications({ params, callbacks }) {
  const classificationType = params?.type;

  try {
    const response = yield call(api.fetchUserClassifications, params);
    yield put(
      Actions.fetchUserClassificationsSuccess(
        classificationType,
        response?.data
      )
    );
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response?.data);
    }
  } catch (error) {
    yield put(
      Actions.fetchUserClassificationsFail(classificationType, error)
    );
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

export default function* userClassifications() {
  yield all([
    takeEvery(
      Actions.FETCH_USER_CLASSIFICATIONS_REQUEST,
      fetchUserClassifications
    ),
  ]);
}
